import React from "react";
const ClearIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    d: "M15.385 8l.615.615L12.615 12 16 15.385l-.615.615L12 12.615 8.615 16 8 15.385 11.384 12 8 8.615 8.615 8 12 11.385 15.385 8z",
    opacity: ".6",
    fill: "currentColor"
  }
));
var ClearIcon_default = ClearIcon;
export {
  ClearIcon_default as default
};
//# sourceMappingURL=ClearIcon.js.map
